<template>
  <section>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="float-right">
            <!-- FILTRO -->
            <FilterSystem
              class=""
              :columns="filterColumns"
              :reset="resetFilterSystem"
              :sort="sort"
              :dir="dir"
              :filterSystem="filtersDash"
              :filterOldQuery="oldQuery"
              :key="filterkey"
              @callApi="filterNow($event)"
            />
          </div>
        </div>
      </div>
      <!-- <div class="col-12">
        <template v-if="!graphsDataLoading">
          <div class="row mt-2">
            <div class="col-md-2" v-for="(item, label) in cardData">
              <div class="">
                <span class="card p-2 mb-2 text-center">
                  <h6>
                    {{ $t("lang.column." + label) }}
                    <Tooltip
                      :text="showTooltip(label)"
                      :width="''"
                      class="px-0 mx-0"
                      v-if="showTooltip(label)"
                    >
                      <div
                        class="ml-3 mt-0 pt-1 circle bg-secondary d-flex align-items-center justify-content-center"
                      >
                        <div class="question-mark text-white">?</div>
                      </div>
                    </Tooltip>
                  </h6>
                  <h4>{{ item.total }}</h4>
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div v-for="graph in graphsData" class="col-md-2">
                  <div class="p-2">
                    <doughnut-chart
                      class="py-2"
                      :chart-data="graph"
                      :options="graph.options"
                      :height="200"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <LoadingSpinner v-if="graphsDataLoading" />
      </div> -->

      <span v-if="okstat && showOtherUsers && otherUsers == 0"
        >No users billing</span
      >

      <div v-if="showOtherUsers && otherUsers > 0">
        <div class="mt-5">

        </div>

        <h4 class="mt-5">Teams</h4>
        <Tabs 
            :tabSelected="tabSelected" 
            :tabs="tabs" 
            @change="changeTab($event)" 
            class="mx-5 mb-3"
        />
        <Tooltip class="float-right" :text="$t('lang.general.warning_delete_team')">
          <button
            @click="executeAction('delete')"
            :disabled="loadingDeleteTeam || teamuserselecteddata.length == 0"
            class="btn btn-sm btn-danger mr-2"
          >
            <i class="mr-1 icon-remove"></i>{{ $t("lang.general.delete_mailboxes") }}
          </button>
        </Tooltip>
        <button
          class="btn btn-sm btn-primary mr-2 float-right"
          @click="addSalesChild"
          type="submit"
        >
          <i class="icon-plus1"></i> {{ $t("lang.label.team") }}
        </button>

        <button
          class="btn btn-sm btn-secondary mr-2 float-right"
          :disabled="teamuserselecteddata.length == 0"
          @click="openAssignUser"
        >Assign user</button>
        <br />
        <Modal :name="'assignuser'" :size="'50'" :max-width="350">
          <div class="p-4 text-center">
            <label>
              <h4>Change team to?</h4>
            </label>
          </div>
          <div class="px-4 pb-4 text-center">
            <div v-if="assignUserLoading" class="text-center">
              <span class="spinner-border loading-spinner text-primary"></span>
            </div>
            <div v-else>
              <select v-model="assignUserSelectedTeam" class="form-control mb-3">
                <option :value="null" disabled>Select a team...</option>
                <option v-for="team in assignUserTeams" :key="team.id" :value="team.id">
                  {{ team.label }}
                </option>
              </select>
              <button
                class="btn btn-primary btn-sm px-3 py-2"
                :disabled="!assignUserSelectedTeam"
                @click="assignUserToTeam"
              >
                <i class="icon-checkmark mr-1"></i> Confirm
              </button>
            </div>
          </div>
        </Modal>
        <Modal :name="'saleschild'" :size="'50'" :max-width="350">
          <div class="p-4 text-center">
            <label>
              <h4>{{ $t("lang.user.add") }}</h4>
            </label>
          </div>
          <div class="px-4 pb-4 text-center">
            <AddTeamMember
              :add="true"
              :child="true"
              :client_id="team_id"
              @newForm="addChildMemberSales($event)"
            />
          </div>
        </Modal>
        <Modal :name="'updatesaleschild'" :size="'50'" :max-width="350">
          <div class="p-4 text-center">
            <label>
              <h4>Asign {{ updatesalesname }} to another sales</h4>
            </label>
          </div>
          <div class="px-4 pb-4 text-center">
            <AddTeamMember
              :add="false"
              :child="true"
              :client_id="team_id"
              @newForm="updateChildMemberSales($event)"
            />
          </div>
        </Modal>

        <br />

        <!-- TEAMS TABLE-->
        <span
          v-if="loadingDeleteTeam"
          class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
        ></span>
        <div class="card p-2 table-responsive">
          <Table 
            v-if="listTeams.length > 0" 
            class="mx-2 w-100" 
            :headers="headersTeam" 
            :cols="colsTeam" 
            :data="listTeams"             
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="key"
            @goToOrder="goToOrder"
            @checkselectedteamusers="checkselectedteamusers"
            @updateSalesChild="updateSalesChild"
            >
          </Table>
        </div>

        <!-- <h4 class="mt-5">Prospecting users</h4>
        <ListSDRTeam :client_id="team_id"></ListSDRTeam> -->
      </div>

      <modal
        name="emails"
        :clickToClose="true"
        class="modal-preview p-4"
        :resizable="true"
        height="auto"
        width="70%"
        :scrollable="true"
        :max-width="800"
        :ref="modalkey"
      >
        <div class="row px-4 py-2" v-if="emails">
          <div v-for="(email, index) in emails" :key="'email-' + index" class="col-12 py-2 card my-2">
            <small>
              <i class="icon-checkmark text-success" v-if="email.link_id"></i>
              {{ email.from[0].email }}</small
            >
            <small>{{ getEmailDate(email.date) }}</small>
            <Fieldset :title="email.subject" :mykey="email.id" :open="false">
              {{ email.snippet }}
            </Fieldset>
          </div>
        </div>
        <LoadingSpinner v-else />
      </modal>
    </div>
  </section>
</template>
<script>
import {
  usersService,
  monitorService,
  clientsService,
  campaignsService
} from "@/_services";
import { mapState, mapMutations } from "vuex";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import ListSDRTeam from "@/components/SalesRepresentative/ListSDRTeam.vue";
import AddTeamMember from "@/components/Onboarding/AddTeamMember.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import moment from "moment";
import Tooltip from "@/components/Common/Tooltip.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";

export default {
  data() {
    return {
      updatesalesfrom: false,
      updatesalesname: false,
      graphsDataLoading: true,
      graphsData: [],
      cardData: {},
      filterColumns: [
        {
          name: "Email Provider",
          name_: "email",
          type: "list",
          list: [
            { id: "gmail", name: "gmail" },
            { id: "outlook", name: "outlook" }
          ],
          field: "cn.provider"
        },
        {
          name: "Email Sync",
          name_: "email sync",
          type: "list",
          list: [
            { id: 1, name: "yes" },
            { id: 0, name: "no" }
          ],
          field: "cn.activated"
        },
        {
          name: "Sending method",
          name_: "sending method",
          type: "list",
          list: [
            { id: 1, name: "Nylas" },
            { id: 2, name: "SMTP" },
            { id: 3, name: "Google Api" }
          ],
          field: "cn.send_method"
        },
        {
          name: "Email status",
          name_: "user status id",
          type: "list",
          list: [
            { id: 1, name: "Activated" },
            { id: 2, name: "Inactive" },
            { id: 3, name: "Deleted" },
            { id: 4, name: "Pending Workspace" },
            { id: 5, name: "Waiting Replace" }
          ],
          field: "u.user_status_id"
        },
        {
          name: "Campaign status",
          name_: "email",
          type: "list",
          list: [
            { id: 1, name: "Pending" },
            { id: 2, name: "Active" },
            { id: 3, name: "Stop" },
            { id: 4, name: "Deleted" }
          ],
          field: "csh.campaign_status_id"
        }
      ],
      filtersDash: {},
      sort: "",
      dir: "",
      oldQuery: "",
      resetFilterSystem: false,
      filterkey: 3444,
      loadingDeleteTeam: false,
      cantexecuted: 0,
      emails: false,
      modalkey: 212112,
      list: Array,
      stats: [],
      okstat: false,
      total_danger_sent: 0,
      total_new_emails_sent_today: 0,
      total_warning_sent: 0,
      total_calendly: 0,
      total_campaign: 0,
      total_viewer: 0,
      total_nylas: 0,
      total_contacts: 0,
      total_available_contacts: 0,
      total_quantity_per_day: 0,
      total_recurring_emails_sent_today: 0,
      total_deliv: 0,
      bounce_total: 0,
      total_spam_rate: 0,
      total_opening: 0,
      total_answering: 0,
      total_apoint: 0,
      total_av: 0,
      total_meeting_valid: 0,
      total_meeting_absent: 0,
      total_meeting_canceled: 0,
      lines: 0,
      otherUsers: 0,
      adminUsers: 0,
      key: 1,
      fieldsLoading: true,
      teamuserselected: [],
      teamuserselecteddata: [],
      assignUserTeams: [],
      assignUserSelectedTeam: null,
      assignUserLoading: false,
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          name: 'Teams with active mailboxes',
        },
        2: {
          id: 2,
          name: 'Teams without active mailboxes',
        },
      },
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      colsTeam: [
        [
          {
            value1: "id",
            value2: "selectedteamuser",
            value3: "parent_sales_representative_id",
            emit: "checkselectedteamusers",
            type: "teamsClientFormat",
            format: 1,
          }
        ],
        [
          {
            value: "user",
            value1: "salesChildObject",
            value2: "parent_sales_representative_id",
            emit: "updateSalesChild",
            type: "teamsClientFormat",
            format: 2,
          }
        ],
        [
          {
            value1: "targets",
            value2: "target_status_id",
            btnId: "target_id",
            emit: "goToOrder",
            type: "teamsClientFormat",
            format: 3,
          }
        ],
        [
          {
            value: "active_user",
            class: "text-center h6 front-weight-bold",
          }
        ],
        [
          {
            // value1: "prospectors_active",
            // value2: "prospectors_warmingup",
            // value3: "prospectors_resting",
            value: "prospecting_status",
            format: 4,
            type: "teamsClientFormat",
          }
        ]
      ],
      headersTeam: [
        {
          label: "Select",
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "User",
          percentage: "0.1%",
          class: "overflowhide",  
          id: 1,
        },
        {
          label: this.$t("lang.orders.orders"),
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Active email licenses",
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Status in campaigns",
          percentage: "0.1%",
          class: "overflowhide",
          id: 1,
        }
      ],
    };
  },
  props: {
    filters: Array,
    team_id: String, //esto en realidad es client_id
    showOtherUsers: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.filtersDash.getEmailTeam = false;
    this.filterNow();
  },
  components: {
    ItemMonitor,
    LoadingSpinner,
    Fieldset,
    FilterSystem,
    Tooltip,
    DoughnutChart,
    AddTeamMember,
    ListSDRTeam,
    Table,
    Tabs,
  },
  computed: {
    showTooltip() {
      return label => {
        if (label == "first_contact") {
          return this.$t("lang.label.email_step");
        } else {
          return false;
        }
      };
    },
    // Lista filtrada para el componente Table de Teams (solo role_id != 2)
    listTeams() {
      // Primero filtrar por role_id
      let filtered = this.list.filter(item => item.role_id != 2);
      
      // Filtrar según el tab seleccionado
      if (this.tabSelected === 1) {
        // Tab 1: Teams with active mailboxes (active_user > 0)
        filtered = filtered.filter(item => {
          const value = item.active_user;
          if (value !== null && value !== undefined && value !== '' && !isNaN(value)) {
            return Number(value) > 0;
          }
          return false;
        });
      } else if (this.tabSelected === 2) {
        // Tab 2: Teams without active mailboxes (active_user <= 0)
        filtered = filtered.filter(item => {
          const value = item.active_user;
          if (value === null || value === undefined || value === '' || isNaN(value)) {
            return true; // Incluir valores nulos/undefined como sin active mailboxes
          }
          return Number(value) <= 0;
        });
      }
      
      // Calcular el total de active_user según el tab
      let active_user_total = 0;
      if (this.tabSelected === 1) {
        // Tab 1: Sumar todos los active_user > 0
        active_user_total = filtered.reduce((sum, item) => {
          const value = item.active_user;
          if (value !== null && value !== undefined && value !== '' && !isNaN(value)) {
            return sum + Number(value);
          }
          return sum;
        }, 0);
      } else {
        // Tab 2: Siempre mostrar 0
        active_user_total = 0;
      }
      
      // Si hay datos, agregar fila de totales al final
      if (filtered.length > 0) {
        return [
          ...filtered,
          {
            totalRow: true,
            id: "total_row",
            active_user: active_user_total,
            // Mantener otros campos necesarios para evitar errores en el renderizado
            user: "",
            targets: "",
            prospectors_active: "",
            prospectors_warmingup: "",
            prospectors_resting: "",
            selectedteamuser: false,
            salesChildObject: null,
            parent_sales_representative_id: null,
            target_status_id: null,
            role_id: null
          }
        ];
      }
        console.log("Usuarios con role_id != 2 (otros usuarios):", filtered);
      return filtered;
    }
  },
  methods: {
    hasData(row) {
      if (
        row.prospectors_warmingup == "0" &&
        row.prospectors_active == "0" &&
        row.prospectors_resting == "0" &&
        row.prospectors_total != "0"
      ) {
        return true;
      } else {
        return false;
      }
    },
    openAssignUser() {
      this.assignUserSelectedTeam = null;
      this.assignUserTeams = [];
      this.assignUserLoading = true;
      this.$modal.show("assignuser");
      usersService.getSalesByClient(this.team_id).then(result => {
        console.log(result)
        this.assignUserTeams = result.map(item => ({
          id: item.sales_representative_id,
          label: item.first_name + ' ' + item.last_name + ' (' + item.email + ')'
        }));
        this.assignUserLoading = false;
      });
    },
    assignUserToTeam() {
      const newParentId = this.assignUserSelectedTeam;
      console.log(newParentId);
      const promises = this.teamuserselecteddata.map(userId => {
        const item = this.list.find(i => i.id === userId);
        if (item && item.child_sales_representative_id) {
          return usersService.updateSalesRepParent(
            item.child_sales_representative_id,
            newParentId
          );
        }
        return Promise.resolve();
      });
      Promise.all(promises).then(() => {
        this.$modal.hide("assignuser");
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 1500
        });
        this.filterNow();
      });
    },
    addSalesChild() {
      this.$modal.show("saleschild");
    },
    updateSalesChild(from, actualsalesname) {
      // Si recibe un objeto (desde el componente Table), extraer los valores
      if (typeof from === 'object' && from !== null) {
        this.updatesalesfrom = from.id;
        this.updatesalesname = from.name;
      } else {
        this.updatesalesfrom = from;
        this.updatesalesname = actualsalesname;
      }
      this.$modal.show("updatesaleschild");
    },
    goToOrder(target_id){
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },
    changeTab(value) {
        if (value == this.tabSelected) return;
        this.tabSelected = value;
    },
    updateChildMemberSales(member) {
      usersService
        .updateSalesRepParent(
          this.updatesalesfrom,
          member.sales_representative_id.id
        )
        .then(resp => {
          this.$modal.hide("updatesaleschild");
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 1500
          });
          this.saleskey++;
          this.updatesalesfrom = false;
          this.updatesalesname = false;
          this.filterNow();
        });
    },
    addChildMemberSales(member) {


      this.updatesalesfrom = false;
      usersService
        .addSalesRepChild(member.sales_representative_id.id, member.client_id, member.howManyTeams)
        .then(resp => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 1500
          });
          this.$modal.hide("saleschild");
          this.saleskey++;
          this.filterNow();
        })
        .catch(() => {
          this.$modal.hide("saleschild");
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error"),
            showConfirmButton: true
          });
        });
    },
    getBadgeTargetStatus(status) {
      switch (status) {
        case "1":
          return "btn-success";
          break;
        case "2":
          return "btn-danger";
          break;
        case "3":
          return "btn-warning";
          break;
        case "4":
          return "btn-success";
          break;
        case "5":
          return "btn-secondary";
          break;
      }
    },
    loadEmailTeam() {
      this.filtersDash.getEmailTeam = true;
      this.filterNow();
    },
    dataTarget() {
      usersService.getGroupList(this.team_id).then(result => {
        this.dataUsers = result;
        this.list.forEach(el => {
          const targets = result.find(e => e.id === el.id);
          if (targets) el.targets = targets.targets;
        });
        this.loadingteam = false;
      });
    },
    vueAppEnv() {
      return process.env.VUE_APP_ENV;
    },
    isOliverCalendar(link) {
      if (link && link.includes("/calendar/")) {
        return true;
      }
      return false;
    },
    copyCalendarLink(calendar_link) {
      if (this.copyToClipboard(calendar_link)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    copyEmbedCode(calendar_link) {
      var copyText =
        '<div style="min-width:320px;height:630px;"><iframe width="100%" height="100%" style="border:0" src="' +
        calendar_link +
        '" frameborder="0" allowfullscreen></iframe></div>';
      if (this.copyToClipboard(copyText)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    // Nueva función separada
    checkselectedteamusers() {
      this.teamuserselecteddata = [];
      this.list.forEach((item, index) => {
        if (item.selectedteamuser) {
          this.teamuserselecteddata.push(item.id);
        }
      });
      console.log("Usuarios seleccionados para eliminar:", this.teamuserselecteddata);
    },
    executeAction(type, params) {
      if (type == "opencalendar") {
        this.$emit("opencalendar", params);
        return;
      }
      if (type == "openTeam") {
        this.$emit("openTeam", params);
        return;
      }

      if (type == "delete") {
        this.$swal({
          type: "warning",
          title: this.$t("lang.general.warning_delete_team"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
          cancelButtonText: this.$t("lang.button.cancel")
        }).then(result => {
          if (result.value) {
            this.loadingDeleteTeam = true;
            usersService.deleteUsers(this.teamuserselecteddata).then(r => {
              this.$emit("refresh");
              this.loadingDeleteTeam = false;
            });
          }
        });
      }
    },
    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id
        )
        .then(
          result => {
            window.open(result, "_blank");
          },
          error => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },
    connectSpark(user) {
      if (user.provider == "gmail") {
        var scopes = [
          //"https://www.googleapis.com/auth/gmail.readonly",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/gmail.modify",
          "https://www.googleapis.com/auth/userinfo.email",
          "https://www.googleapis.com/auth/gmail.labels",
          "https://www.googleapis.com/auth/calendar"
        ];
        // var redirect_uri = "https://oliver-api.localhost.com/oauth/callback";
        //var redirect_uri = "https://app.oliverlist.com/dashboard";
        var redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        //console.log(redirect_uri);
        var client_id =
          "679504478551-85b7vh81acj9h8176g9fmpo0pomicgl3.apps.googleusercontent.com";
        var scope = scopes.join(" ");
        var auth_url = "https://accounts.google.com/o/oauth2/auth";
        auth_url += "?redirect_uri=" + encodeURIComponent(redirect_uri);
        auth_url += "&client_id=" + encodeURIComponent(client_id);
        auth_url += "&scope=" + encodeURIComponent(scope);
        auth_url += "&approval_prompt=force";
        auth_url += "&access_type=offline";
        auth_url += "&response_type=code";
        auth_url += "&login_hint=" + user.nylas_email_sync;

        window.open(auth_url, "_blank");
      } else {
        let client_id = "0d136df4-3c69-4c23-b7b9-54217c864e0c"; //APP OLIVER
        let redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        let scope =
          "Calendars.Read.Shared Calendars.ReadWrite Calendars.ReadWrite.Shared Contacts.Read Contacts.ReadWrite Mail.Read Mail.ReadWrite Mail.Send OnlineMeetings.ReadWrite  User.Read profile openid offline_access";
        let state = Math.random()
          .toString(36)
          .substring(7);
        let auth_url =
          "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
          "?client_id=" +
          encodeURIComponent(client_id) +
          "&response_type=code" +
          "&redirect_uri=" +
          encodeURIComponent(redirect_uri) +
          "&scope=" +
          encodeURIComponent(scope) +
          "&state=" +
          encodeURIComponent(state) +
          "&login_hint=" +
          user.nylas_email_sync;

        window.open(auth_url, "_blank");
      }
    },
    openEmails(user_id, limit, page) {
      this.emails = false;
      this.$modal.show("emails");
      this.modalkey++;
      clientsService.getNylasEmails(user_id, limit, page).then(result => {
        this.emails = result;
      });
    },
    closeModal() {
      this.emails = false;
      this.$modal.hide("emails");
    },
    getEmailDate(emaildate) {
      var momentObj = moment(emaildate * 1000);
      var momentString = momentObj.format("YYYY-MM-DD H:m:s");
      return momentString;
    },
    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
    loadMonitors(results) {
      let cantstats;
      cantstats = 0;
      results.forEach(result => {
        if (result.role_id != "2") {
          this.otherUsers++;
          return true;
        } else {
          this.adminUsers++;
        }
        monitorService
          .getMonitorUser(result.id, "stats")
          .then(result2 => {
            this.stats[result.id] = result2;
            cantstats++;
            if (cantstats >= this.list.length - this.otherUsers) {
              this.loadTotals();
            }
          })
          .then(r => {
            this.okstat = true;
            this.$forceUpdate();
          });
      });
      this.okstat = true;
    },
    loadTotals() {
      this.totalDangerSent();
      this.totalViewer();
      this.totalNylas();
      this.totalCalendly();
    },

    totalDangerSent() {
      this.stats.forEach(result => {
        if (result === undefined || result === false) {
          return true;
        }
        this.lines++;

        if (result.emails_per_day_total.danger) {
          this.total_danger_sent =
            this.total_danger_sent + result.emails_per_day_total.danger;
        }
        if (result.emails_per_day_total.warning) {
          this.total_warning_sent =
            this.total_warning_sent + result.emails_per_day_total.warning;
        }

        let quantity_per_day = Object.entries(result.quantity_per_day);
        let available_contacts = Object.entries(result.available_contacts);
        let new_emails_sent_today = Object.entries(
          result.new_emails_sent_today
        );
        let recurring_emails_sent_today = Object.entries(
          result.recurring_emails_sent_today
        );

        let workflow = Object.entries(result.workflow);

        available_contacts.forEach((res, key) => {
          if (
            res[1] <= 50 &&
            quantity_per_day[key] !== undefined &&
            quantity_per_day[key][1] > 0 &&
            workflow[key] !== undefined &&
            workflow[key][1] == 0
          ) {
            this.total_campaign++;
          }

          if (quantity_per_day[key][1] > 0) {
            this.total_quantity_per_day =
              this.total_quantity_per_day +
              parseFloat(quantity_per_day[key][1]);
          }

          if (available_contacts[key][1] > 0) {
            this.total_available_contacts =
              this.total_available_contacts +
              parseFloat(available_contacts[key][1]);
          }

          if (new_emails_sent_today[key][1] > 0) {
            this.total_new_emails_sent_today =
              this.total_new_emails_sent_today +
              parseFloat(new_emails_sent_today[key][1]);
          }

          if (recurring_emails_sent_today[key][1] > 0) {
            this.total_recurring_emails_sent_today =
              this.total_recurring_emails_sent_today +
              parseFloat(recurring_emails_sent_today[key][1]);
          }
        });

        this.total_contacts = this.total_contacts + result.emails_sent_b;

        if (result.deliverability) {
          this.total_deliv = this.total_deliv + result.deliverability;
        }

        if (result.bounce_total) {
          this.bounce_total =
            this.bounce_total +
            this.getPercentage(result.bounce_total, result.emails_sent);
        }

        if (result.spam_rate) {
          this.total_spam_rate =
            this.total_spam_rate + parseFloat(result.spam_rate);
        }

        let percentage = this.getPercentage(
          result.emails_opened,
          result.emails_sent_b
        );

        percentage = this.getPercentage(result.events, result.emails_sent_b);
        if (percentage > 0) {
          this.total_apoint = parseFloat(this.total_apoint) + percentage;
        }

        this.total_answering =
          parseFloat(this.total_answering) + result.answering_rate_max;

        this.total_meeting_valid =
          this.total_meeting_valid + parseInt(result.events_total);
        this.total_meeting_absent =
          this.total_meeting_absent + parseInt(result.absent);
        this.total_meeting_canceled =
          this.total_meeting_canceled + parseInt(result.canceled);

        this.total_av = parseFloat(this.total_av) + parseFloat(result.avday);
      });
    },
    filterNow(filter) {
      this.graphsData = [];
      this.list = [];
      this.cardData = {};
      this.okstat = false;
      if (filter != undefined) {
        this.filtersDash = filter;
        this.filtersDash.getGraphData = true;
      }
      monitorService
        .getMonitorList(this.team_id, this.filtersDash)
        .then(result => {
          if (result.length == 0) {
            this.okstat = true;
            this.graphsDataLoading = false;
          } else {
            this.list = result;
            this.list.forEach((item, index) => {
              item.user = item.name + ' ' + item.lastname + ' (' + item.id + ')';
              item.salesChildObject = {
                id: item.child_sales_representative_id,
                name: item.name + ' ' + item.lastname,
              }
            });
            this.filterNowGraphData();
            // this.dataTarget(); Esta funcion es innecesaria, ya que getMonitorList ya obtiene toda la informacion del target.
            this.loadMonitors(result);
          }
        });
    },

    filterNowGraphData() {
      this.filtersDash.getGraphData = true;
      this.filtersDash.getEmailTeam = true;
      monitorService
        .getMonitorList(this.team_id, this.filtersDash)
        .then(result => {
          if (result) {
            this.graphsData = [];
            this.cardData = {};
            Object.entries(result).forEach((value, index) => {
              if (value[1].graph_type != "pie") {
                this.cardData[value[0]] = value[1].data;
                return;
              }

              if (value[1].data[0].label == null) {
                return;
              }

              let graphsDataN = {
                labels: [],
                datasets: [{ data: [], backgroundColor: [] }],
                options: {
                  cutoutPercentage: 10,
                  responsive: true,
                  aspectRatio: 1,
                  maintainAspectRatio: false,
                  devicePixelRatio: 2,
                  title: {
                    display: true,
                    text: this.$t("lang.column." + value[0]),
                    innerText: ""
                  },
                  legend: {
                    display: false
                  }
                } 
              };
              value[1].data.forEach((item, index2) => {
                graphsDataN.labels.push(item.label);
                var randomColor = Math.floor(Math.random() * 16777215).toString(
                  16
                );
                graphsDataN.datasets[0].backgroundColor.push("#" + randomColor);
                graphsDataN.datasets[0].data.push(item.total);
              });
              this.graphsData.push(graphsDataN);
            });

            //('cardData', this.cardData);
            this.graphsDataLoading = false;
          }
        });
      this.filtersDash.getGraphData = false;
    },

    loadAgencyStatsGraphs() {
      this.graphsDataLoading = true;
      this.filtersDash.getGraphData = true;
      campaignsService
        .getAgencyStatsRange(
          this.range.startDate,
          this.range.endDate,
          this.client,
          this.filtersDash
        )
        .then(result => {
          this.graphsData = [];
          this.cardData = {};
          Object.entries(result.activity_by_date).forEach((value, index) => {
            if (value[1].graph_type != "pie") {
              this.cardData[value[0]] = value[1].data;
              return;
            }

            if (value[1].data[0].label == null) {
              return;
            }

            let graphsDataN = {
              labels: [],
              datasets: [{ data: [], backgroundColor: [] }],
              options: {
                cutoutPercentage: 10,
                responsive: true,
                aspectRatio: 1,
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                title: {
                  display: true,
                  text: this.$t("lang.column." + value[0]),
                  innerText: ""
                },
                legend: {
                  display: false
                }
              }
            };
            value[1].data.forEach((item, index2) => {
              graphsDataN.labels.push(item.label);
              var randomColor = Math.floor(Math.random() * 16777215).toString(
                16
              );
              graphsDataN.datasets[0].backgroundColor.push("#" + randomColor);
              graphsDataN.datasets[0].data.push(item.total);
            });
            this.graphsData.push(graphsDataN);
          });

          this.graphsDataLoading = false;
        });
      this.filtersDash.getGraphData = false;
    },

    getPercentage(cant, total) {
      if (total == 0 || cant == 0) {
        return parseFloat(0);
      }

      var result = (cant * 100) / total;

      result = parseFloat(result);

      return result;
    },
    totalCalendly() {
      this.list.forEach(result => {
        if (!result.calendly && result.role_id == 2) {
          this.total_calendly++;
        }
      });
    },
    totalNylas() {
      this.list.forEach(result => {
        if (
          (result.nylas_email_sync_status == "0" ||
            result.nylas_email_sync_status == "") &&
          result.role_id == 2
        ) {
          this.total_nylas++;
        }
      });
    },
    totalViewer() {
      this.list.forEach(result => {
        if (!result.team_viewer && result.role_id == 2) {
          this.total_viewer++;
        }
      });
    }
  }
};
</script>
<style scoped>
.circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
}
</style>
